
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Text/Text.st.css.js";
import "../Text/Caption.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_CounterBadge";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_CounterBadge__root","text":"wds_1_182_0_CounterBadge__text","caption":"wds_1_182_0_CounterBadge__caption","numberContent":"wds_1_182_0_CounterBadge__numberContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




